let imgOpti = {
  data() {
    return {};
  },
  mounted() {},
  methods: {
    optimize(image, width) {
      if (!image) return "";

      let img = image;
      let length = img.length;
      let format = img.slice(length - 3, length);

      if (format == "png") {
        return this.optiFilter(image, width);
      } else {
        return this.optiJpg(image, width, format);
      }
    },
    optiFilter(image, width) {
      if (!image) return "";

      let size = width + "x0/";
      let quality = `filters:fill(transparent):quality(85):format(png)`;

      let imageService = "//img2.storyblok.com/fit-in/";
      let path = image.replace("//a.storyblok.com", "");
      let url = imageService + size + quality + path;

      return imageService + size + quality + path;
    },

    optiJpg(image, width, format) {
      /* if (!image) return ""; */
      if (format == 'peg') {
        format = 'j' + format
      }
      let size = width + "x0/";
      /* let quality = "filters%3Aquality%2880%29"; */
      let quality = `filters:quality(85):format(${format})`;

      let imageService = "//img2.storyblok.com/";
      let path = image.replace("//a.storyblok.com", "");
      let url = imageService + size + quality + path;

      return imageService + size + quality + path;
    }
  }
};

export default imgOpti;
